import styled from 'styled-components'

export const ScaledMainPanelWrapper = styled.div`
  position: relative;
  width: 240px;
  transform: ${(props) => `scale(${props.scale})`};
  transform-origin: top left;
`
export default ScaledMainPanelWrapper
